// Empty State Component for filtered results
import React from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faFilter, 
  faSearch, 
  faExclamationCircle,
  faPlus 
} from '@fortawesome/free-solid-svg-icons';
import styles from './PromptEmptyState.module.css';

interface PromptEmptyStateProps {
  type: 'no-prompts' | 'no-results' | 'loading';
  filterActive?: boolean;
  onCreateNew?: () => void;
  onResetFilters?: () => void;
}

export const PromptEmptyState: React.FC<PromptEmptyStateProps> = ({
  type,
  filterActive = false,
  onCreateNew,
  onResetFilters
}) => {
  const { t } = useTranslation('promptGenerator');

  if (type === 'loading') {
    return (
      <div className={styles.emptyState}>
        <div className={styles.spinner} />
        <div className={styles.title}>{t('promptGenerator.emptyState.loading')}</div>
      </div>
    );
  }

  if (type === 'no-results') {
    return (
      <div className={styles.emptyState}>
        <FontAwesomeIcon icon={faSearch} className={styles.icon} />
        <div className={styles.title}>{t('promptGenerator.emptyState.noResults')}</div>
        <div className={styles.subtitle}>
          {filterActive 
            ? t('promptGenerator.emptyState.adjustFilters')
            : t('promptGenerator.emptyState.noMatch')
          }
        </div>
        {filterActive && onResetFilters && (
          <button className={styles.actionButton} onClick={onResetFilters}>
            <FontAwesomeIcon icon={faFilter} />
            {t('promptGenerator.emptyState.resetFilters')}
          </button>
        )}
      </div>
    );
  }

  return (
    <div className={styles.emptyState}>
      <FontAwesomeIcon icon={faExclamationCircle} className={styles.icon} />
      <div className={styles.title}>{t('promptGenerator.emptyState.noPrompts')}</div>
      <div className={styles.subtitle}>
        {t('promptGenerator.emptyState.createFirst')}
      </div>
      {onCreateNew && (
        <button className={styles.actionButton} onClick={onCreateNew}>
          <FontAwesomeIcon icon={faPlus} />
          {t('promptGenerator.emptyState.createNew')}
        </button>
      )}
    </div>
  );
};
